const ShopSubTitle = ({ href, title, subTitle, textColor, index }) => {
  return (
    <a
      href={`#${href}`}
      className={`shop-menu-item`}
      style={{ color: textColor }}
    >
      <p className="item-text font-amaticsc-bold">{title}</p>
      <p className="item-sub-text font-zenkurenaido">{subTitle}</p>
    </a>
  );
};

export default ShopSubTitle;
